import { atom, useAtom } from 'jotai';

type SubTab = {
  clientName: string;
  subTab: string;
  payload?: any;
};

export type SubTabIssueItem = {
  fieldName: string;
  fieldError: string;
  requirementType: string;
  method: (name: string) => void;
};

type SetupList = {
  id: number;
  clientName: string;
  subTab: string;
  warnings: SubTabIssueItem[];
  errors: SubTabIssueItem[];
};

const editClientSubTabAtom = atom<SubTab[]>([]);
const editClientSetupListAtom = atom<SetupList[]>([]);

export function useClient() {
  const [activeEditClientSubTab, setActiveEditClientSubTab] =
    useAtom(editClientSubTabAtom);
  const [editClientSetupList, setEditClientSetupList] = useAtom(
    editClientSetupListAtom
  );

  function makeActiveEditClientSubTab(
    clientName: string,
    subTab: string,
    payload?: any
  ) {
    setActiveEditClientSubTab((prev) => {
      const index = prev.findIndex((item) => item.clientName === clientName);

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = { clientName, subTab, payload };
        return updated;
      } else {
        return [...prev, { clientName, subTab, payload }];
      }
    });
  }

  function renameEditClientSubTab(previousName: string, nextName: string) {
    setActiveEditClientSubTab((prev) => {
      const previous = prev.find((item) => item.clientName === previousName);
      if (!previous) return prev;

      return [
        ...prev.filter(
          (item) =>
            item.clientName !== previousName && item.clientName !== nextName
        ),
        { ...previous, clientName: nextName },
      ];
    });
  }

  function removeSubTab(clientName: string) {
    setActiveEditClientSubTab((prev) =>
      prev.filter((item) => item.clientName !== clientName)
    );
  }

  function updateEditClientSetupList(newEntry: SetupList) {
    setEditClientSetupList((prev) => {
      const index = prev.findIndex((item) => item.id === newEntry.id);

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = newEntry;
        return updated;
      } else {
        return [...prev, newEntry];
      }
    });
  }

  return {
    activeEditClientSubTab,
    makeActiveEditClientSubTab,
    renameEditClientSubTab,
    removeSubTab,
    editClientSetupList,
    updateEditClientSetupList,
  };
}
